export default () => !(window.innerWidth >= 768);



// WEBPACK FOOTER //
// ./scripts/util/isMobile.js